import React from 'react';
import { LegalLayout, LegalBlock, InfoGrid, IconList } from './LegalLayout';
import { useLanguage } from '../../i18n/LanguageContext';
export function PoliticaPrivacidad() {
  const {
    lang
  } = useLanguage();
  const es = lang === 'es';
  return <LegalLayout titleEs="Política de Privacidad" titleCa="Política de Privacitat" subtitleEs="Cómo tratamos y protegemos tus datos personales" subtitleCa="Com tractem i protegim les teves dades personals" data-id="element-616">
      {/* BLOCK 1 */}
      <LegalBlock title={es ? '¿Quién es el responsable?' : 'Qui és el responsable?'} data-id="element-617">
        <InfoGrid items={[{
        label: 'Titular',
        value: 'GEORGINA FAHLE RUIZ'
      }, {
        label: 'NIF/CIF',
        value: '46996968X'
      }, {
        label: es ? 'Domicilio' : 'Domicili',
        value: 'C/ Boters, 4, Vilafranca del Penedès, 08720 Barcelona'
      }, {
        label: es ? 'Email' : 'Correu',
        value: 'georginaconstelaciones@gmail.com'
      }, {
        label: 'Web',
        value: 'www.georginaconstelaciones.com'
      }]} data-id="element-618" />
      </LegalBlock>

      {/* BLOCK 2 */}
      <LegalBlock title={es ? 'Principios Aplicados' : 'Principis Aplicats'} data-id="element-619">
        <IconList items={es ? ['Licitud, lealtad y transparencia', 'Minimización de datos', 'Limitación del plazo de conservación', 'Integridad y confidencialidad'] : ['Licitud, lleialtat i transparència', 'Minimització de dades', 'Limitació del termini de conservació', 'Integritat i confidencialitat']} data-id="element-620" />
        <p className="mt-4" data-id="element-621">
          {es ? 'El Titular te informará del plazo de conservación según la finalidad del tratamiento.' : "El Titular t'informarà del termini de conservació segons la finalitat del tractament."}
        </p>
      </LegalBlock>

      {/* BLOCK 3 */}
      <LegalBlock title={es ? '¿Cómo obtenemos tus datos?' : 'Com obtenim les teves dades?'} data-id="element-622">
        <p data-id="element-623">
          {es ? 'Para navegar por el sitio Web no es necesario facilitar datos personales.' : 'Per navegar pel lloc web no és necessari facilitar dades personals.'}
        </p>
        <p data-id="element-624">
          {es ? 'Sí se recaban datos cuando:' : 'Sí que es recullen dades quan:'}
        </p>
        <ul className="list-none space-y-1.5 pl-1" data-id="element-625">
          {es ? <>
              <li data-id="element-626">· Contactas a través del formulario de contacto</li>
              <li data-id="element-627">· Envías un correo electrónico</li>
              <li data-id="element-628">
                · Te suscribes a nuestro boletín de noticias (a través de
                MailChimp, MailRelay, SendinBlue u otros)
              </li>
            </> : <>
              <li data-id="element-629">· Contactes a través del formulari de contacte</li>
              <li data-id="element-630">· Envies un correu electrònic</li>
              <li data-id="element-631">
                · Et subscrius al nostre butlletí de notícies (a través de
                MailChimp, MailRelay, SendinBlue o altres)
              </li>
            </>}
        </ul>
      </LegalBlock>

      {/* BLOCK 4 */}
      <LegalBlock title={es ? 'Tus Derechos' : 'Els Teus Drets'} data-id="element-632">
        <p data-id="element-633">{es ? 'Tienes derecho a:' : 'Tens dret a:'}</p>
        <IconList items={es ? ['Solicitar acceso a tus datos personales', 'Rectificar datos inexactos', 'Solicitar la cancelación de tus datos', 'Limitar el tratamiento de tus datos', 'Oponerte al tratamiento', 'Portabilidad de tus datos'] : ['Sol·licitar accés a les teves dades personals', 'Rectificar dades inexactes', 'Sol·licitar la cancel·lació de les teves dades', 'Limitar el tractament de les teves dades', 'Oposar-te al tractament', 'Portabilitat de les teves dades']} data-id="element-634" />
        <p className="mt-4" data-id="element-635">
          {es ? 'Para ejercer estos derechos, envía un correo con copia de tu DNI a:' : 'Per exercir aquests drets, envia un correu amb còpia del teu DNI a:'}
        </p>
        <p className="flex items-center gap-2" data-id="element-636">
          <span data-id="element-637">📧</span>
          <a href="mailto:georginaconstelaciones@gmail.com" className="text-[#c49a4a] underline hover:text-[#1a3a2a]" data-id="element-638">
            georginaconstelaciones@gmail.com
          </a>
        </p>
        <p data-id="element-639">
          {es ? 'También tienes derecho a reclamar ante la Agencia Española de Protección de Datos (AEPD).' : "També tens dret a reclamar davant l'Agència Espanyola de Protecció de Dades (AEPD)."}
        </p>
      </LegalBlock>

      {/* BLOCK 5 */}
      <LegalBlock title={es ? '¿Para qué usamos tus datos?' : 'Per a què fem servir les teves dades?'} data-id="element-640">
        <p data-id="element-641">
          {es ? 'Tus datos se utilizan para las siguientes finalidades:' : "Les teves dades s'utilitzen per a les finalitats següents:"}
        </p>
        <div className="grid sm:grid-cols-2 gap-4 mt-4" data-id="element-642">
          {(es ? [['📋', 'Formularios de contacto', 'Para responder a tus consultas y solicitudes.'], ['📧', 'Suscripciones', 'Para gestionar el envío de boletines e información sobre talleres y próximas fechas.'], ['⚖️', 'Cumplimiento legal', 'Para cumplir con las obligaciones legales aplicables.'], ['📊', 'Análisis de navegación', 'A través de cookies, para mejorar la experiencia en el sitio Web.'], ['📱', 'Redes sociales', 'Para gestionar los perfiles en redes sociales. No se utilizarán datos de seguidores para publicidad individual.']] : [['📋', 'Formularis de contacte', 'Per respondre a les teves consultes i sol·licituds.'], ['📧', 'Subscripcions', "Per gestionar l'enviament de butlletins i informació sobre tallers i properes dates."], ['⚖️', 'Compliment legal', 'Per complir amb les obligacions legals aplicables.'], ['📊', 'Anàlisi de navegació', "A través de cookies, per millorar l'experiència al lloc web."], ['📱', 'Xarxes socials', "Per gestionar els perfils a xarxes socials. No s'utilitzaran dades de seguidors per a publicitat individual."]]).map(([icon, title, desc], i) => <div key={i} className="bg-[#f7f4ef] border border-sage-light/20 rounded-md p-4" data-id="element-643">
              <div className="flex items-center gap-2 mb-1.5" data-id="element-644">
                <span className="text-xl" data-id="element-645">{icon}</span>
                <h3 className="font-medium text-[#1a3a2a] text-[15px]" data-id="element-646">
                  {title}
                </h3>
              </div>
              <p className="text-[14px] text-[#2c3e2d] leading-snug" data-id="element-647">{desc}</p>
            </div>)}
        </div>
      </LegalBlock>

      {/* BLOCK 6 */}
      <LegalBlock title={es ? 'Seguridad y Conservación' : 'Seguretat i Conservació'} data-id="element-648">
        {es ? <>
            <p data-id="element-649">
              El Titular adopta las medidas técnicas y organizativas necesarias
              para proteger tus datos personales y garantizar su
              confidencialidad.
            </p>
            <p data-id="element-650">
              Los datos se conservarán mientras sean necesarios para la
              finalidad para la que fueron recabados o hasta que solicites su
              supresión, salvo que exista obligación legal de conservarlos.
            </p>
          </> : <>
            <p data-id="element-651">
              El Titular adopta les mesures tècniques i organitzatives
              necessàries per protegir les teves dades personals i garantir-ne
              la confidencialitat.
            </p>
            <p data-id="element-652">
              Les dades es conservaran mentre siguin necessàries per a la
              finalitat per a la qual van ser recollides o fins que en
              sol·licitis la supressió, llevat que hi hagi obligació legal de
              conservar-les.
            </p>
          </>}
      </LegalBlock>

      {/* BLOCK 7 */}
      <LegalBlock title={es ? 'Destinatarios' : 'Destinataris'} data-id="element-653">
        <p data-id="element-654">
          {es ? 'Tus datos pueden ser tratados por los siguientes proveedores de servicio:' : 'Les teves dades poden ser tractades pels proveïdors de servei següents:'}
        </p>
        <ul className="list-none space-y-1.5 pl-1" data-id="element-655">
          {es ? <>
              <li data-id="element-656">
                · Mailrelay, Mailchimp o SendinBlue (gestión de comunicaciones
                por email)
              </li>
              <li data-id="element-657">· Google Analytics (análisis de navegación)</li>
              <li data-id="element-658">· DoubleClick por Google (publicidad)</li>
            </> : <>
              <li data-id="element-659">
                · Mailrelay, Mailchimp o SendinBlue (gestió de comunicacions per
                correu)
              </li>
              <li data-id="element-660">· Google Analytics (anàlisi de navegació)</li>
              <li data-id="element-661">· DoubleClick de Google (publicitat)</li>
            </>}
        </ul>
        <p data-id="element-662">
          {es ? 'Consulta la Política de Cookies para más detalle.' : 'Consulta la Política de Cookies per a més detalls.'}
        </p>
      </LegalBlock>

      {/* BLOCK 8 */}
      <LegalBlock title={es ? 'Aceptación y Cambios' : 'Acceptació i Canvis'} data-id="element-663">
        {es ? <>
            <p data-id="element-664">Al usar este sitio Web aceptas esta Política de Privacidad.</p>
            <p data-id="element-665">
              El Titular se reserva el derecho a modificarla para adaptarla a
              novedades legislativas o cambios en las prácticas del sector.
            </p>
          </> : <>
            <p data-id="element-666">
              En utilitzar aquest lloc web acceptes aquesta Política de
              Privacitat.
            </p>
            <p data-id="element-667">
              El Titular es reserva el dret de modificar-la per adaptar-la a
              novetats legislatives o canvis en les pràctiques del sector.
            </p>
          </>}
      </LegalBlock>
    </LegalLayout>;
}